import { type TokenGroup } from "../../types";

export const black = {
  name: "black",
  variables: {
    default: { type: "color", value: { dark: "#000000", light: "#000000" } },
  },
} as const satisfies TokenGroup<"black">;
